<template>
    <div>
        <!-- 标题 -->
        <div class="BillingPage-title">
            <Row>
                <Col span="12">
                    <Breadcrumb>
                        <BreadcrumbItem>{{$t('Bill.Billing.title')}}</BreadcrumbItem>
                    </Breadcrumb>
                </Col>
                <Col span="12">
                    <Select v-if="companyId == 258" v-model="cloudType" filterable placeholder="" style="width: 150px;float: right;margin-top: -7px;" @on-change="searchCloud">
                      <Option v-for="item in cloudList" :key="item.id" :value="item.id">{{ item.name }}</Option>
                    </Select>
                    <Select v-else v-model="stateSearchKey" filterable placeholder="" style="width: 150px;float: right;margin-top: -7px;" @on-change="searchRegion">
                        <Option v-for="item in regionList" :key="item.id" :value="item.regionType">{{ item.name }}</Option>
                    </Select>
                </Col>
            </Row>
        </div>
        <!--图表 -->
        <Row :gutter="16">
            <!-- 近10日各服务每日花费分析 -->
            <Col span="12">
                <Card :padding="8">
                    <Row>
                        <Col>
                            <Row :gutter="10">
                                <Col span="10" class="title">{{$t('Bill.Billing.recent10DaysAnalysis')}}{{$t('Bill.Billing.unit')}}{{swireDailyGrowthCurveUnit}}) </Col>

                                 <!-- 服务 -->
                                <Col span="7" style="margin-top:5px">
                                    <Select v-model="server" multiple filterable :max-tag-count="1" @on-change="serverChange(server)" :placeholder="$t('Bill.Billing.servicename')">
                                        <Checkbox v-model="singleServer" @on-change="selectServerAll" style="display: block;text-align:right;">{{$t('Bill.Billing.selectAll')}}</Checkbox>
                                        <Option v-for="(item,index) in serverList" :value="item.id" :key="index">{{ item.name}}</Option>
                                    </Select>
                                </Col>

                                <!-- 账号 -->
                                <Col span="7" style="margin-top:5px">
                                    <Select v-model="account" multiple filterable :max-tag-count="1" @on-change="accountChange(account)" :placeholder="$t('Bill.Billing.linkedaccountid')">
                                        <Checkbox v-model="singleAccount" @on-change="selectAccountAll" style="display: block;text-align:right;">{{$t('Bill.Billing.selectAll')}}</Checkbox>
                                        <Option v-for="(item, index) in accountList" :value="item.id" :key="index">{{item.id}}</Option>
                                    </Select>
                                </Col>

                                <Col span="24" style="margin-bottom: 0px;">
                                    <!--详情  -->
                                    <Col class="iconStyle">
                                        <Icon type="md-apps" class="download" style="font-size: 20px;" @click="everyDaySpendDetail"/>
                                    </Col>
                                    <!-- 导出 -->
                                    <Col class="iconStyle">
                                        <Icon type="ios-cloud-download-outline" class="download" style="font-size: 20px;" @click="exportEveryDaySpend"/>
                                    </Col>

                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <div id="everyDaySpend" style="width:100%;height: 290px;"></div>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <!-- 近10日各服务每日花费分析表格 -->
            <Modal v-model="everyDaySpendModel" :title="$t('Bill.Billing.recent10DaysAnalysis')" :mask-closable="false" width="800px">
                <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="everyDaySpendColumns" :data="everyDaySpendDate" size="small" :loading="everyDaySpendLoading"></Table>
                <div slot="footer">
                    <Button type="info" @click="exportEveryDaySpendDetail" :loading="modalLoadingEveryDaySpend">{{$t('Bill.Billing.export')}}</Button>
                    <Button type="text" size="large" @click="everyDaySpendCaseReset">{{ $t('alarms.common.cancel') }}</Button>
                </div>
            </Modal>

            <!-- 月度花费 -->
            <Col span="12">
                <Card :padding="8">
                    <Row :gutter="10">
                        <Col>
                            <Row>
                                <Col span="12" class="title">{{$t('Bill.Billing.monthlyCost')}}{{$t('Bill.Billing.unit')}}{{swireDailyGrowthCurveUnit}})</Col>
                                <Col span="12">
                                    <!--详情  -->
                                    <Col class="iconStyle">
                                        <Icon type="md-apps" class="download" style="font-size: 20px;" @click="monthSpendDetail();"/>
                                    </Col>
                                    <!-- 导出 -->
                                    <Col class="iconStyle">
                                        <Icon type="ios-cloud-download-outline" class="download" style="font-size: 20px;" @click="exportMonthSpend"/>
                                    </Col>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <div id="monthSpend" style="width:100%;height: 300px;"></div>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <!-- 月度花费表格 -->
            <Modal v-model="monthSpendModel" :title="$t('Bill.Billing.monthlyCost')"  :mask-closable="false" width="800px">
                <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="monthSpendColumns" :data="monthSpendDate" size="small" :loading="monthSpendLoading"></Table>
                <div slot="footer">
                    <Button type="info" @click="exportMonthSpendDetail" :loading="modalLoadingMonthSpend">{{$t('Bill.Billing.export')}}</Button>
                    <Button type="text" size="large" @click="monthSpendCaseReset">{{ $t('alarms.common.cancel') }}</Button>
                </div>
            </Modal>
        </Row>

        <Row :gutter="16">
            <!--花费日增长曲线  -->
             <Col span="12">
                <Card :padding="8">
                    <Row :gutter="10">
                        <Col>
                            <Row>
                                <Col span="12" class="title">{{$t('Bill.Billing.dailyCostCurve')}}{{$t('Bill.Billing.unit')}}{{swireDailyGrowthCurveUnit}})</Col>
                                <Col span="12">
                                    <!--详情  -->
                                    <Col class="iconStyle">
                                        <Icon type="md-apps" class="download" style="font-size: 20px;" @click="swireopsSpendDetail();"/>
                                    </Col>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                           <div id="swireopsSpend" style="width:100%;height: 300px;"></div>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <!-- 花费日增长曲线表格 -->
            <Modal v-model="swireopsSpendModel" :title="$t('Bill.Billing.eachDimentionCost')" :mask-closable="false" width="800px">
                <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="swireopsSpendColumns" :data="swireopsSpendDate" size="small" :loading="swireopsSpendLoading" ></Table>
                <div slot="footer">
                    <Button type="info" @click="exportSwireopsSpendDetail" :loading="modalLoadingSwireopsSpend">{{$t('Bill.Billing.export')}}</Button>
                    <Button type="text" size="large" @click="swireopsSpendCaseReset">{{ $t('alarms.common.cancel') }}</Button>
                </div>
            </Modal>

            <!-- 各维度花费比例 -->
            <Col span="12">
                <Card :padding="8">
                    <Row :gutter="10">
                        <Col>
                            <Row>
                                <Col span="8" class="title">{{$t('Bill.Billing.eachDimentionCost')}}{{$t('Bill.Billing.unit')}}{{swireDailyGrowthCurveUnit}})</Col>
                                 <!-- 维度(服务) -->
                                <Col style="width:150px;float:right;margin-left: 10px;margin-top: 5px;">
                                    <Select v-model="dimension" multiple filterable :max-tag-count="1" @on-change="dimensionChange(dimension)" placeholder="">
                                        <Checkbox v-model="singleDimension" @on-change="selectDimensionAll" style="display: block;text-align:right;">{{$t('alarms.common.allSelected')}}</Checkbox>
                                        <Option v-for="item in dimensionList" :value="item.name" :key="item.id">{{ item.name}}</Option>
                                    </Select>
                                </Col>
                                <!-- 年月 -->
                                <Col style="width:200px;float: right;margin-top: 5px;">
                                    <Select v-model="yearMonth" multiple filterable :max-tag-count="1" @on-change="yearMonthChange(yearMonth)" placeholder="">
                                        <Checkbox v-model="singleYearMonth" @on-change="selectYearMonthAll" style="display: block;text-align:right;">{{$t('alarms.common.allSelected')}}</Checkbox>
                                        <Option v-for="item in yearMonthList" :value="item.name" :key="item.id">{{ item.name}}</Option>
                                    </Select>
                                </Col>
                                <Col span="24">
                                    <!--详情  -->
                                    <Col class="iconStyle">
                                        <Icon type="md-apps" class="download" style="font-size: 20px;" @click="spendbyDimensionDetail();"/>
                                    </Col>
                                    <!-- 导出 -->
                                    <Col class="iconStyle">
                                        <Icon type="ios-cloud-download-outline" class="download" style="font-size: 20px;" @click="exportSpendbyDimension"/>
                                    </Col>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <div id="spendbyDimension" style="width:100%;height: 273px;"></div>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <!-- 各维度花费比例表格 -->
            <Modal v-model="spendbyDimensionModel" :title="$t('Bill.Billing.theProportionOfEachDimension')" :mask-closable="false" width="800px">
                <Table :no-data-text="$t('common.noData')" class="table-css" height="400" :columns="spendbyDimensionColumns" :data="spendbyDimensionDate" size="small" :loading="spendbyDimensionLoading"></Table>
                <div slot="footer">
                    <Button type="info" @click="exportSpendbyDimensionDetail" :loading="modalLoadingSpendbyDimension">{{$t('Bill.Billing.export')}}</Button>
                    <Button type="text" size="large" @click="spendbyDimensionCaseReset">{{ $t('alarms.common.cancel') }}</Button>
                </div>
            </Modal>
        </Row>

        <!-- S3 -->
        <Row>
            <Col span="24">
                <Card :padding="8">
                    <Row>
                        <Col class="title">{{$t('Bill.Billing.S3')}}</Col>
                        <Col>
                        <Col style="float: right;margin-top: 5px;margin-left: 10px;">
                                <Icon type="ios-cloud-download-outline" class="download" @click="exportTableCurrentBudgetInstanceList"/>
                            </Col>
                            <!-- 账号 -->
                            <Col style="width:240px;float: right;margin-top: 2px;">
                                <Select v-model="accountS3" multiple filterable :max-tag-count="1" @on-change="accountS3Change(accountS3)" :placeholder="$t('Bill.Billing.linkedaccountid')">
                                    <Checkbox v-model="singleAccountS3" @on-change="selectAccountS3All" style="display: block;text-align:right;">{{$t('Bill.Billing.selectAll')}}</Checkbox>
                                    <Option v-for="item in accountS3List" :value="item.id" :key="item.id">{{ item.id}}</Option>
                                </Select>
                            </Col>
                        </Col>
                    </Row>
                    <Table :no-data-text="$t('common.noData')" height="420" style="width: 100.1%;" :columns="tableCurrentBudgetInstanceListColumns" :data="tableCurrentBudgetInstanceListDate" size="small" :loading="tableCurrentBudgetInstanceListLoadings"></Table>
<!--                    <Modal v-model="tableCurrentBudgetInstanceListModal" :title="$t('Bill.Billing.detail')"  :mask-closable="false" width="800px">-->
<!--                        <Table :no-data-text="$t('common.noData')" class="table-css" max-height="400" :columns="tableCurrentBudgetInstanceListColumnDetail" :data="tableCurrentBudgetInstanceListDetailDate" size="small" :loading="tableCurrentBudgetInstanceListLoading"></Table>-->
<!--                        <div slot="footer">-->
<!--                            <Button type="info" @click="exportTableCurrentBudgetInstanceListDetail" :loading="modalLoadingTableCurrentBudgetInstanceList">{{$t('Bill.Billing.export')}}</Button>-->
<!--                            <Button type="text" size="large" @click="tableCurrentBudgetInstanceListCaseReset">{{ $t('alarms.common.cancel') }}</Button>-->
<!--                        </div>-->
<!--                    </Modal>-->
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/cookieUtil";

    var billingPageVue = {};
    export default {
        name: 'BillingPage',
        data () {
            return {
                companyId: getCookie(global.companyId), // 258是丰田公司
                accountS3:[],
                singleAccountS3:false,
                account: [],
                singleAccount: false,
                server: [],
                singleServer: false,
                dimension: [],
                singleDimension: false,
                yearMonth:[],
                singleYearMonth:false,
                stateSearchKey:'北京',
                cloudType: 0,
                cloudList: [{
                  id:0,
                  name: 'AWS',
                  cloudType:'AWS'
                },{
                  id:1,
                  name: 'Alibaba Cloud',
                  cloudType: 'AlibabaCloud'
                },{
                  id:5,
                  name: 'HUAWEI Cloud',
                  cloudType: 'HUAWEICloud'
                }],
                regionList:[{
                    id:0,
                    name:this.$t('Bill.RI.beijing'),
                    regionType:'北京'
                },{
                    id:1,
                    name:this.$t('Bill.RI.Singapore'),
                    regionType:'Singapore'
                }],
                accountList: [],
                serverList: [],
                dimensionList: [],
                yearMonthList:[],
                accountS3List:[],
                // echarts实例
                chartEveryDaySpend:'',
                chartMonthSpend:'',
                chartSwireopsSpend:'',
                chartSpendbyDimension:'',
                // 数组
                xaxisData:[],
                // 近10日各服务每日花费分析
                modalLoadingEveryDaySpend:false,
                costComparisonNearlyTenDaysUnit:'',
                dateList:[],
                beforeDiscount:[],
                everyDaySpendLoading: false,
                everyDaySpendModel:false,
                everyDaySpendColumns: [{
                    title: this.$t('Bill.Billing.billingday'),
                    key: 'billingday'
                },
                {
                    title: 'BillingType',
                    key: 'billingtype'
                },
                {
                    title: this.$t('Bill.Billing.linkedaccountid'),
                    key: 'linkedaccountid'
                },
                {
                    title: this.$t('Bill.Billing.region'),
                    key: 'region'
                },
                {
                    title: this.$t('Bill.Billing.servicename'),
                    key: 'servicename'
                },
                {
                    title: this.$t('Bill.Billing.unblendedcosUnit'),
                    key: 'unblendedcosUnit'
                }],
                everyDaySpendDate:[],
                // 月度花费表格
                modalLoadingMonthSpend:false,
                monthlyCostUnit:'',
                monthlyCostDateList:[],
                monthlyCostBeforeDiscount:[],
                monthlyCostAfterDiscount:[],
                monthSpendLoading: false,
                monthSpendModel:false,
                monthSpendColumns: [{
                    title: 'billingtype',
                    key: 'billingtype'
                },
                {
                    title: this.$t('Bill.Billing.linkedaccountid'),
                    key: 'linkedaccountid'
                },
                {
                    title: this.$t('Bill.Billing.month'),
                    key: 'month'
                },
                {
                    title: this.$t('Bill.Billing.unblendedcosUnit'),
                    key: 'unblendedcosUnit'
                },
                {
                    title: 'region',
                    key: 'region'
                }],
                monthSpendDate:[],
                // 花费日增长曲线表格
                modalLoadingSwireopsSpend:false,
                swireDailyGrowthCurveUnit:'',
                monthListSwireDailyGrowthCurve:[],
                dateListSwireDailyGrowthCurve:[],
                multipleLinesSwireDailyGrowthCurve:[],
                swireopsSpendLoading: false,
                swireopsSpendModel:false,
                swireopsSpendColumns: [{
                    title: 'month',
                    key: 'date'
                },
                {
                    title: this.$t('Bill.Billing.unblendedcosUnit'),
                    key: 'costUnit'
                }],
                swireopsSpendDate:[],
                // 各维度花费比例表格
                modalLoadingSpendbyDimension: false,
                dimensionCostUnit:'',
                selected:{},
                dimensionCostSwireMultiDimen:[],
                newDimensionCostSwireMultiDimenList:[],
                spendbyDimensionLoading: false,
                spendbyDimensionModel:false,
                spendbyDimensionColumns: [{
                    title: this.$t('Bill.Billing.dimenkey'),
                    key: 'dimenkey'
                },
                {
                    title: this.$t('Bill.Billing.keyvalue'),
                    key: 'keyvalue'
                },
                {
                    title: this.$t('Bill.Billing.month'),
                    key: 'month'
                },
                {
                    title: this.$t('Bill.Billing.unblendedcosUnit'),
                    key: 'unblendedcostUnit'
                }],
                spendbyDimensionDate:[],
                // s3
                tableCurrentBudgetInstanceListModal:false,
                tableCurrentBudgetInstanceListLoading: false,
                modalLoadingTableCurrentBudgetInstanceList:false,
                tableCurrentBudgetInstanceListLoadings:false,
                tableCurrentBudgetInstanceListColumns: [{
                    title:' ',
                    key:'resourceId',
                    fixed:'left'
                }],
                tableCurrentBudgetInstanceListColumnDetail: [
                    {
                        title: this.$t('Bill.Billing.resourceId'),
                        key: 'resourceId'
                    },
                    {
                        title: this.$t('Bill.Billing.usageDate'),
                        key: 'usageDate'
                    },
                    {
                        title: this.$t('Bill.Billing.usageQuantity'),
                        key: 'usageQuantity'
                    }
                ],
                tableCurrentBudgetInstanceListDate:[],
                tableCurrentBudgetInstanceListDetailDate:[]
            }
        },
        beforeCreate: function() {
            billingPageVue = this
        },
        mounted:function(){
            billingPageVue.showAll();
            // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartEveryDaySpend.resize();
                self.chartMonthSpend.resize();
                self.chartSwireopsSpend.resize();
                self.chartSpendbyDimension.resize();
            });
        },
        created(){
            this.$nextTick(function() {
                billingPageVue.costComparisonNearlyTenDaysChart();
                billingPageVue.monthlyCostChart();
                billingPageVue.swireDailyGrowthCurveChart();
                billingPageVue.dimensionCostChart();
            });
        },
        methods: {
            /************************接口***************************************/
            /********************************************/
            // billing页面近10日下拉框
            billingNearlyTenDaysComboBox:function(){
              let data = {}
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                this.$api.swireBilling.billingNearlyTenDaysComboBox(data)
                .then(res => {
                    // 账号
                    this.accountList = res.data.accountComBox;
                    // 服务
                    this.serverList=res.data.serviceTypeComBox;
                })
            },
            // 近10日花费分析详情
            costComparisonNearlyTenDaysParticulars:function(){
                this.everyDaySpendLoading=true;
              let data = {
                serviceName: this.server,
                account: this.account
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                this.$api.swireBilling.costComparisonNearlyTenDaysParticulars(data)
                .then(res => {
                    this.everyDaySpendDate = res.data;
                    this.everyDaySpendLoading=false;
                })
            },
            /********************************************/
            // 月度花费详情
            monthlyCostParticulars:function(){
                this.monthSpendLoading=true;
                let data = {}
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                this.$api.swireBilling.monthlyCostParticulars(data)
                .then(res => {
                    this.monthSpendDate = res.data;
                    this.monthSpendLoading=false;
                })
            },
            /********************************************/
            // 太古花费日增长详情
            swireDailyGrowthCurveParticulars(params) {
                this.swireopsSpendLoading=true;
                let data = {}
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                this.$api.swireBilling.swireDailyGrowthCurveParticulars(data)
                .then(res => {
                    this.swireopsSpendDate = res.data;
                    this.swireopsSpendLoading=false;
                })
            },
            /********************************************/
            // 各维度花费比例
            billingDimensionComboBox:function(){
              let data = {}
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                this.$api.swireBilling.billingDimensionComboBox(data)
                .then(res => {
                    // 年月
                    this.yearMonthList = res.data.monthComBox;
                    // 维度(项目)
                    this.dimensionList=res.data.dimensionComBox;
                    if (this.yearMonthList.length > 0) {
                      this.yearMonth=[this.yearMonthList[0].name];
                      this.dimension=[this.dimensionList[1].name];
                    }
                })
            },
            // 各维度花费比例详情
            dimensionCostParticulars:function(){
                this.spendbyDimensionLoading=true;
              let data = {
                dimensionDate: this.yearMonth,
                dimension: this.dimension
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                this.$api.swireBilling.dimensionCostParticulars(data)
                .then(res => {
                    this.spendbyDimensionDate = res.data;
                    this.spendbyDimensionLoading=false;
                })
            },
            /********************************************/
            // s3下拉框
            listS3ComboBox:function(){
              let data = {}
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.businessRegion = this.stateSearchKey
              }
                this.$api.swireBilling.listS3ComboBox(data)
                .then(res => {
                    this.accountS3List=res.data;
                })
            },
            // s3表格
            listS3StorageLastWeek:function(){
                this.tableCurrentBudgetInstanceListLoadings=true;
              let data = {
                accountList: this.accountS3
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.businessRegion = this.stateSearchKey
              }
                this.$api.swireBilling.listS3StorageLastWeek(data)
                .then(res => {
                    this.s3StorageLastWeekDTOS=res.data.s3StorageLastWeekDTOS;
                    this.lastEightDaysDateList=res.data.lastEightDaysDateList;
                    this.tableCurrentBudgetInstanceListDate=[];
                    this.tableCurrentBudgetInstanceListColumns=[{
                        title:' ',
                        key:'resourceId',
                        fixed:'left'
                    }];
                    // 内容
                    for(var i=0;i<this.s3StorageLastWeekDTOS.length;i++){
                        this.tableCurrentBudgetInstanceListDate.push({
                            resourceId:this.s3StorageLastWeekDTOS[i].resourceId,
                            0:this.s3StorageLastWeekDTOS[i].lastEightDaysUsageQuantityList[0],
                            1:this.s3StorageLastWeekDTOS[i].lastEightDaysUsageQuantityList[1],
                            2:this.s3StorageLastWeekDTOS[i].lastEightDaysUsageQuantityList[2],
                            3:this.s3StorageLastWeekDTOS[i].lastEightDaysUsageQuantityList[3],
                            4:this.s3StorageLastWeekDTOS[i].lastEightDaysUsageQuantityList[4],
                            5:this.s3StorageLastWeekDTOS[i].lastEightDaysUsageQuantityList[5],
                            6:this.s3StorageLastWeekDTOS[i].lastEightDaysUsageQuantityList[6],
                            7:this.s3StorageLastWeekDTOS[i].lastEightDaysUsageQuantityList[7]
                        });
                    }
                    // 标题
                    for(var j=0;j<this.lastEightDaysDateList.length;j++){
                        this.tableCurrentBudgetInstanceListColumns.push({
                            title:this.lastEightDaysDateList[j],
                            key:j
                        });
                    }
                }).finally(() => {
                  this.tableCurrentBudgetInstanceListLoadings=false;
                })
            },
            showAll: function(){
               billingPageVue.billingNearlyTenDaysComboBox();
               billingPageVue.billingDimensionComboBox();
               billingPageVue.listS3StorageLastWeek();
               billingPageVue.listS3ComboBox();
            },
            // 丰田公司用户切换云平台
            searchCloud() {
              this.server=[];
              this.account=[];
              this.dimension=[];
              this.yearMonth=[];
              this.accountS3 = [];
              // billingPageVue.init();
              billingPageVue.showAll();
              billingPageVue.costComparisonNearlyTenDaysChart();
              billingPageVue.monthlyCostChart();
              billingPageVue.swireDailyGrowthCurveChart();
              billingPageVue.dimensionCostChart();
            },
            /************************按状态筛选***************************************/
            // 按状态筛选
            searchRegion: function(){
                this.server=[];
                this.account=[];
                this.dimension=[];
                this.yearMonth=[];
                this.accountS3 = [];
                // billingPageVue.init();
                billingPageVue.showAll();
                billingPageVue.costComparisonNearlyTenDaysChart();
                billingPageVue.monthlyCostChart();
                billingPageVue.swireDailyGrowthCurveChart();
                billingPageVue.dimensionCostChart();

            },
            /******************所有全选*******************************************************/
            /***********账号**************************/
            selectAccountAll() {
                this.account = []
                if (this.singleAccount) {
                    this.accountList.map((item) => {
                        this.account.push(item.id)
                    })
                } else {
                    this.account = []
                }
            },
            // 切换账号
            accountChange(val) {
                billingPageVue.costComparisonNearlyTenDaysChart();
                if (val.length === this.accountList.length&&val.length!=0) {
                    this.singleAccount = true
                } else {
                    this.singleAccount = false
                }
            },
            /***********S3账号**************************/
            selectAccountS3All() {
                this.accountS3 = []
                if (this.singleAccountS3) {
                    this.accountS3List.map((item) => {
                        this.accountS3.push(item.id)
                    })
                } else {
                    this.accountS3 = []
                }
            },
            // 切换账号
            accountS3Change(val) {
                billingPageVue.listS3StorageLastWeek();
                if (val.length === this.accountS3List.length&&val.length!=0) {
                    this.singleAccountS3 = true
                } else {
                    this.singleAccountS3 = false
                }
            },
            /***********服务**************************/
            selectServerAll() {
                this.server = []
                if (this.singleServer) {
                    this.serverList.map((item) => {
                        this.server.push(item.id)
                    })
                } else {
                    this.server = []
                }
            },
            // 切换服务
            serverChange(val) {
                billingPageVue.costComparisonNearlyTenDaysChart();
                if (val.length === this.serverList.length&&val.length!=0) {
                    this.singleServer = true
                } else {
                    this.singleServer = false
                }
            },
            /***********年月**************************/
            selectYearMonthAll() {
                this.yearMonth = []
                if (this.singleYearMonth) {
                    this.yearMonthList.map((item) => {
                        this.yearMonth.push(item.name)
                    })
                } else {
                    this.yearMonth = []
                }
            },
            // 切换年月
            yearMonthChange(val) {
                billingPageVue.dimensionCostChart();
                if (val.length === this.yearMonthList.length&&val.length!=0) {
                    this.singleYearMonth = true
                } else {
                    this.singleYearMonth = false
                }
            },
            /***********维度(项目)**************************/
            selectDimensionAll() {
                this.dimension = []
                if (this.singleDimension) {
                    this.dimensionList.map((item) => {
                        this.dimension.push(item.name)
                    })
                } else {
                    this.dimension = []
                }
            },
            // 切换维度(项目)
            dimensionChange(val) {
                billingPageVue.dimensionCostChart();
                if (val.length === this.dimensionList.length&&val.length!=0) {
                    this.singleDimension = true
                } else {
                    this.singleDimension = false
                }
            },
            /******************所有图表*******************************************************/
            init:function(){
                this.$nextTick(function() {
                    billingPageVue.monthSpendLine();
                    billingPageVue.everyDaySpendLine();
                    billingPageVue.spendbyDimensionLine();
                    billingPageVue.swireopsSpendLine();
                });
            },

            // 近10日花费分析图表
            costComparisonNearlyTenDaysChart:function(){
              let data = {
                serviceName: this.server,
                account: this.account
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                this.$api.swireBilling.costComparisonNearlyTenDaysChart(data)
                .then(res => {
                    // 日期
                    this.dateList = res.data.dateList;
                    // 总和花费
                    this.beforeDiscount=res.data.beforeDiscount;
                    this.costComparisonNearlyTenDaysUnit=res.data.unit;
                    billingPageVue.everyDaySpendLine();
                })
            },
            // 近10日各服务每日花费分析(最后一天数据为不完整数据)
            everyDaySpendLine:function(){
                this.chartEveryDaySpend=this.$echarts.init(document.getElementById("everyDaySpend"));
                this.chartEveryDaySpend.setOption({
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        x: 'center',
                        data:[this.$t('Bill.Billing.totalCost')]
                    },
                    series: [{
                        name:this.$t('Bill.Billing.totalCost'),
                        type:'line',
                        data:this.beforeDiscount,
                        itemStyle: {
                            normal: {
                                color: "#c23531",
                                lineStyle: {
                                    color: "#c23531"
                                }
                            }
                        }
                    }],
                    grid: {
                        left: '1%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            data: this.dateList
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                })
            },
            /********************************************/
            // 月度花费图表
            monthlyCostChart:function(){
              let data = {}
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                this.$api.swireBilling.monthlyCostChart(data)
                .then(res => {
                    // 日期
                    this.monthlyCostDateList = res.data.dateList;
                    // 折扣前
                    this.monthlyCostBeforeDiscount=res.data.beforeDiscount;
                    // 折扣后
                    this.monthlyCostAfterDiscount=res.data.afterDiscount;
                    this.monthlyCostUnit=res.data.unit;
                  billingPageVue.monthSpendLine();
                })
            },
            // 月度花费
            monthSpendLine:function(){
                this.chartMonthSpend=this.$echarts.init(document.getElementById("monthSpend"));
                this.chartMonthSpend.setOption({
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    legend: {
                        data:[this.$t('Bill.Billing.beforeDiscount'),this.$t('Bill.Billing.afterDiscount')]
                    },
                    xAxis: {
                        type: 'category',
                        data: this.monthlyCostDateList
                    },
                    yAxis: {
                        type: 'value'
                    },
                    grid: {
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    series: [
                        {
                            name:this.$t('Bill.Billing.beforeDiscount'),
                            type:'bar',
                            barGap:'0%',
                            barMinHeight:1,
                            data:this.monthlyCostBeforeDiscount
                        },
                        {
                            name:this.$t('Bill.Billing.afterDiscount'),
                            type:'bar',
                            barGap:'0%',
                            barMinHeight:1,
                            data:this.monthlyCostAfterDiscount
                        }
                    ]
                })
            },
            /********************************************/
            // 花费日增长图表
            swireDailyGrowthCurveChart:function(){
              let data = {}
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                this.$api.swireBilling.swireDailyGrowthCurveChart(data)
                .then(res => {
                    this.dateListSwireDailyGrowthCurve=res.data.dateList;
                    this.monthListSwireDailyGrowthCurve=res.data.monthList;
                    this.multipleLinesSwireDailyGrowthCurve=res.data.multipleLines;
                    this.swireDailyGrowthCurveUnit=res.data.unit;
                    billingPageVue.swireopsSpendLine();
                })
            },
            // 花费日增长曲线
            swireopsSpendLine:function(){
              this.chartSwireopsSpend=this.$echarts.init(document.getElementById("swireopsSpend"));
              this.chartSwireopsSpend.clear();
              this.chartSwireopsSpend.setOption({
                tooltip: {
                  trigger: 'axis'
                },
                legend: {
                  data:this.monthListSwireDailyGrowthCurve
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  data: this.dateListSwireDailyGrowthCurve
                },
                yAxis: {
                  type: 'value'
                },
                series: this.multipleLinesSwireDailyGrowthCurve
              })
            },
            /********************************************/
            // 维度花费图表
            dimensionCostChart:function(){
              let data = {
                dimensionDate: this.yearMonth,
                dimension: this.dimension
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                this.$api.swireBilling.dimensionCostChart(data)
                .then(res => {
                    this.dimensionCostSwireMultiDimen=res.data.swireMultiDimen;
                    this.dimensionCostUnit=res.data.unit;
                    this.selected=res.data.selected;
                    if(this.dimensionCostSwireMultiDimen==undefined){
                        return;
                    }
                    this.newDimensionCostSwireMultiDimenList=[];
                    for(var i=0;i<this.dimensionCostSwireMultiDimen.length;i++){
                        var DimensionCostSwireMultiDimenCopy = new Object();
                        DimensionCostSwireMultiDimenCopy.name = this.dimensionCostSwireMultiDimen[i].name;
                        this.newDimensionCostSwireMultiDimenList.push(DimensionCostSwireMultiDimenCopy);
                    }
                    billingPageVue.spendbyDimensionLine();
                })
            },
            // 各维度花费比例
            spendbyDimensionLine:function(){
                this.chartSpendbyDimension=this.$echarts.init(document.getElementById("spendbyDimension"));
                this.chartSpendbyDimension.setOption({
                    tooltip : {
                        trigger: 'item',
                        "formatter": function(a){
                            return a.seriesName+'<br/>'+a.name+':'+a.value.toLocaleString()+'('+a.percent+')%'
                        }
                    },
                    legend:{
                        type: 'scroll',
                        orient: 'vertical',
                        top: 10,
                        bottom: 20,
                        left: 'left',
                        data: this.newDimensionCostSwireMultiDimenList,
                        selected: this.selected
                    },
                    series : [
                        {
                            name: '总和花费',
                            type: 'pie',
                            radius : '75%',
                            center: ['55%', '50%'],
                            data:this.dimensionCostSwireMultiDimen,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                })

            },
            /******************所有表格********************************************************/
            /**********近10日各服务每日花费分析*****************/
            // 详情
            everyDaySpendDetail:function(){
                this.everyDaySpendModel=true;
                billingPageVue.costComparisonNearlyTenDaysParticulars();
            },
            //导出详情
            exportEveryDaySpendDetail: function(){
                this.modalLoadingEveryDaySpend = true
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
              let data = {
                "serviceName":this.server,
                "account":this.account,
                "isExportDetail":true
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                // 下载Excel 文件
                this.$api.swireBilling.costComparisonNearlyTenDaysExport(data)
                .then(res => {
                    let fileName = '近10日各服务每日花费分析(详情).xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.modalLoadingEveryDaySpend = false
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            //导出外部
            exportEveryDaySpend: function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
              let data = {
                "serviceName":this.server,
                "account":this.account,
                "isExportDetail":false
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                // 下载Excel 文件
                this.$api.swireBilling.costComparisonNearlyTenDaysExport(data)
                .then(res => {
                    let fileName = '近10日各服务每日花费分析.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            // 取消
            everyDaySpendCaseReset:function(){
                this.everyDaySpendModel=false;
            },
            /***********月度花费**************************/
            // 详情
            monthSpendDetail:function(){
                this.monthSpendModel=true;
                billingPageVue.monthlyCostParticulars();
            },
            //导出详情
            exportMonthSpendDetail: function(){
                this.modalLoadingMonthSpend = true
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
              let data = {
                "serviceName":this.server,
                "isExportDetail":true
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                // 下载Excel 文件
                this.$api.swireBilling.monthlyCostExport(data)
                .then(res => {
                    let fileName = '月度花费(详情).xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.modalLoadingMonthSpend = false
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            //导出外部
            exportMonthSpend: function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
              let data = {
                "isExportDetail":false
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                // 下载Excel 文件
                this.$api.swireBilling.monthlyCostExport(data)
                .then(res => {
                    let fileName = '月度花费.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
             // 取消
            monthSpendCaseReset:function(){
                this.monthSpendModel=false;
            },
            /***********花费日增长曲线**********************/
            // 详情
            swireopsSpendDetail:function(){
                this.swireopsSpendModel=true;
                billingPageVue.swireDailyGrowthCurveParticulars();
            },
            //导出详情
            exportSwireopsSpendDetail: function(){
                this.modalLoadingSwireopsSpend = true
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
              let data = {
                "isExportDetail":true
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                // 下载Excel 文件
                this.$api.swireBilling.swireDailyGrowthCurveParticularsExport(data)
                .then(res => {
                    let fileName = '花费日增长(详情).xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.modalLoadingSwireopsSpend = false
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
             // 取消
            swireopsSpendCaseReset:function(){
                this.swireopsSpendModel=false;
            },
            /***********各维度花费比例**********************/
            // 详情
            spendbyDimensionDetail:function(){
                this.spendbyDimensionModel=true;
                billingPageVue.dimensionCostParticulars();
            },
            //导出详情
            exportSpendbyDimensionDetail: function(){
                this.modalLoadingSpendbyDimension = true
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
              let data = {
                "dimensionDate":this.yearMonth,
                "dimension":this.dimension,
                "isExportDetail":true
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                // 下载Excel 文件
                this.$api.swireBilling.dimensionCostExport(data)
                .then(res => {
                    let fileName = '各维度花费(详情).xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.modalLoadingSpendbyDimension = false;
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            //导出外部
            exportSpendbyDimension: function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
              let data = {
                "dimensionDate":this.yearMonth,
                "dimension":this.dimension,
                "isExportDetail":false
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.region = this.stateSearchKey
              }
                // 下载Excel 文件
                this.$api.swireBilling.dimensionCostExport(data)
                .then(res => {
                    let fileName = '各维度花费.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
             // 取消
            spendbyDimensionCaseReset:function(){
                this.spendbyDimensionModel=false;
            },
            /***********s3表格**********************/
            //详情
            // tableCurrentBudgetInstanceListDetail:function(row){
            //     // 页面打开
            //     this.tableCurrentBudgetInstanceListModal=true;
            //     this.tableCurrentBudgetInstanceListLoading=true;
            //   let data = {
            //     "resourceId":row.resourceId
            //   }
            //   if (this.companyId == 258) {
            //     data.cloudType = this.cloudType
            //   } else {
            //     data.businessRegion = this.stateSearchKey
            //   }
            //     this.$api.swireBilling.listS3StorageDetail(data)
            //     .then(res => {
            //         this.tableCurrentBudgetInstanceListDetailDate = res.data;
            //         this.tableCurrentBudgetInstanceListLoading=false;
            //     })
            // },
            //导出详情
            exportTableCurrentBudgetInstanceListDetail: function(){
                this.modalLoadingTableCurrentBudgetInstanceList = true
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
              let data = {
                "isExportDetail":true
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.businessRegion = this.stateSearchKey
              }
                // 下载Excel 文件
                this.$api.swireBilling.listS3Export(data)
                .then(res => {
                    let fileName = 'S3(详情).xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.modalLoadingTableCurrentBudgetInstanceList = false;
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            //导出外部
            exportTableCurrentBudgetInstanceList: function(){
                this.$Message.loading({
                    duration: 0,
                    content: '正在导出，请稍等...'
                })
              let data = {
                "isExportDetail":false
              }
              if (this.companyId == 258) {
                data.cloudType = this.cloudType
              } else {
                data.businessRegion = this.stateSearchKey
              }
                // 下载Excel 文件
                this.$api.swireBilling.listS3Export(data)
                .then(res => {
                    let fileName = 'S3.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                      navigator.msSaveBlob(blob, fileName);
                    } else {
                      var link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      window.URL.revokeObjectURL(link.href);
                    }
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            },
            // 取消
            tableCurrentBudgetInstanceListCaseReset:function(){
                this.tableCurrentBudgetInstanceListModal=false;
            }
        }
    }
</script>

<style scoped>
    .BillingPage-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
    }
    .ivu-col-span-12
    {
        margin-bottom: 20px;
    }
    .ivu-col-span-24
    {
        margin-bottom: 20px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
    }
     .title
    {
        font-size:13px;
        font-weight: 600;
        padding: 10px;
        float:left;
        color:#000;
    }
    .iconStyle
    {
        float: right;
        cursor: pointer;
        margin-left: 10px;
        margin-top: 8px;
    }
    /* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
    .download
    {
        float: right;
        font-size: 17px;
        margin-right: 4px;
        font-weight: 600;
        cursor: pointer;
    }
</style>




// WEBPACK FOOTER //
// src/components/ebilling/billing_page/BillingPage.vue